<template>
  <div id="card">
    <div v-if="!is_orgs_user">
      <section
        v-if="room.code"
        style="cursor: pointer"
        class="code copy"
        :data-clipboard-text="room.code"
      >
        <p v-if="room.rooms.find(room => room.is_show)" class="grey">进入以下教室，并验证房间码：</p>
      </section>
      <div v-for="room in room.rooms" :key="room.room_id" class="room-wrapper">
        <section class="room">
          <div class="left">
            <h2>{{ room.name }}</h2>
            <h3>房间号：{{ room.number }}</h3>
          </div>
          <div class="right">
            <p class="blue link">
              <a :href="room.url" class="blue">
                <i class="anyteachicon anyteach-link" /> 房间链接
              </a>
            </p>
          </div>
        </section>
      </div>
    </div>
    <div v-else>
      <div v-for="room in room.rooms" :key="room.room_id" class="room-wrapper">
        <section class="room">
          <div class="left copy" :data-clipboard-text="room.name">
            <h2>{{ room.name }}</h2>
            <h3 v-if="copied != room.name" class="blue link">
              <i class="anyteachicon anyteach-copy" /> 复制房间名
            </h3>
            <h3 v-else class="link animated fadeIn">
              复制成功
              <i class="red anyteachicon anyteach-check-circle" />
            </h3>
          </div>
          <div class="right">
            <p class="blue link">
              <a :href="room.url" class="blue">
                <i class="anyteachicon anyteach-link" /> 房间链接
              </a>
            </p>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import Clipboard from "clipboard"
export default {
  name: "card",
  props: ["room", "is_orgs_user"],
  data() {
    return {
      copied: "",
    }
  },
  methods: {
    clipboard() {
      const clipboard = new Clipboard(".copy")
      clipboard.on("success", e => {
        this.copied = e.text
        this.$toast(`已复制：${e.text}`)
      })
      clipboard.on("error", e => {
        this.$toast("复制失败，请手动输入")
      })
    },
  },
  created() {
    this.clipboard()
  },
}
</script>
<style lang="scss" scoped>
@import "./style.scss";
// @import "../../../../static/css/public.scss";
#card {
  border-radius: 5px;
  border: 1px solid #eee;
  margin: 0 0 15px 0;
  padding: 15px 3%;

  h1 {
    font-size: 1.25rem;
    padding: 0;
    margin: 0 0 5px 0;
    @include avenir-demi();
  }
  h2 {
    margin: 0;
    font-size: 1rem;
    line-height: 1.2;
    font-weight: 500;
  }
  h3 {
    font-size: 0.875rem;
    font-weight: 400;
  }

  .link {
    font-weight: 500;
    a:active,
    a:hover {
      color: $blue !important;
    }
  }
  .grey {
    color: $black;
    opacity: 0.6;
  }
  .code {
    text-align: center;
    padding: 0 0 15px 0;
  }
  .room-wrapper {
    border-top: 1px solid #eee;
    padding: 15px 0;
    width: 100%;

    &:first-of-type {
      border-top: none;
      padding-top: 0;
    }
    &:last-of-type {
      padding-bottom: 0;
    }
  }
  .room {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .left {
      text-align: left;
    }
  }
}
</style>
